<div class="flex flex-col h-full w-full items-start overflow-y-auto gap-3">

  <!-- Infos-->
  <div class="flex flex-row w-full">
<!--    Linke Spalte-->
    <div class="flex flex-col w-1/2 gap-1">
      <div class="flex flex-col w-full">
        <span [title]="'Projektname'"
              class="text-gray-500 text-xs font-medium line-clamp-1 shrink-0">Projektname</span>
        <span [title]="project.name || '-'"
              class="text-gray-900 text-sm font-normal line-clamp-1 w-fit">{{ project.name || '-' }}</span>
      </div>
      <div class="flex flex-col w-full">
        <span [title]="'Bauprojektart'"
              class="text-gray-500 text-xs font-medium line-clamp-1 shrink-0">Bauprojektart</span>
        <span
          [title]="project.projectKind ? (project.projectKind | projectKind) : '-'"
          class="text-gray-900 text-sm font-normal line-clamp-1 w-fit"
        >{{ project.projectKind ? (project.projectKind | projectKind) : '-' }}</span>
      </div>

      <div class="flex flex-col w-full">
        <span [title]="'Planungsbeginn'"
              class="text-gray-500 text-xs font-medium line-clamp-1 shrink-0">Planungsbeginn</span>
        <span [title]="project.beginPlanning ? (project.beginPlanning | date: 'dd.MM.yyyy') : '-'"
              class="text-gray-900 text-sm font-normal line-clamp-1 w-fit">{{ project.beginPlanning ? (project.beginPlanning | date: "dd.MM.yyyy") : '-' }}</span>
      </div>

      <div class="flex flex-col w-full">
        <span [title]="'Projektbeteiligte'" class="text-gray-500 text-xs font-medium line-clamp-1 shrink-0">Projektbeteiligte</span>
        <span [title]="project.users?.length ?? '-'"
              class="text-gray-900 text-sm font-normal line-clamp-1 w-fit">{{ project.users?.length ?? '-' }}</span>
      </div>

    </div>

<!--    Rechte Spalte-->
    <div class="flex flex-col w-1/2 gap-1">
      <div class="flex flex-col w-full">
        <span [title]="'Adresse'"
              class="text-gray-500 text-xs font-medium line-clamp-1 shrink-0">Adresse</span>
        <span [title]="(project.street && project.houseNumber) ? (project.street + ' ' + project.houseNumber) : '-'"
              class="text-gray-900 text-sm font-normal line-clamp-1 w-fit">{{ (project.street && project.houseNumber) ? (project.street + ' ' + project.houseNumber) : (project.street || project.houseNumber || '-') }}</span>
      </div>
      <div class="flex flex-col w-full">
        <span [title]="'Ort'" class="text-gray-500 text-xs font-medium line-clamp-1 shrink-0">Ort</span>
        <span
          [title]="(project.zipCode || project.buildingPlace) ? ((project.zipCode || '') + ' ' + (project.buildingPlace || '')).trim() : '-'"
          class="text-gray-900 text-sm font-normal line-clamp-1 w-fit"
        >{{ (project.zipCode || project.buildingPlace) ? ((project.zipCode || '') + ' ' + (project.buildingPlace || '')).trim() : '-' }}</span>
      </div>

      <div class="flex flex-col w-full">
        <span [title]="'Bundesland'" class="text-gray-500 text-xs font-medium line-clamp-1 shrink-0">Bundesland</span>
        <span [title]="project.state ? (project.state | projectState) : '-'"
              class="text-gray-900 text-sm font-normal line-clamp-1 w-fit">{{ project.state ? (project.state | projectState) : '-' }}</span>
      </div>

      <div class="flex flex-col w-full">
        <span [title]="'Projektbesitzer*in'" class="text-gray-500 text-xs font-medium line-clamp-1 shrink-0">Projektbesitzer*in</span>
        <span [title]="project.owner || '-'"
              class="text-gray-900 text-sm font-normal line-clamp-1 w-fit">{{ project.owner || '-' }}</span>
      </div>

    </div>

  </div>

  <!-- Karte (nur ab 380px Kartenhöhe sichtbar) -->
  @if (mapReady && showMap) {
<div class="flex flex-row w-full flex-1" style="min-height: 100px;">
    <app-map class="w-full h-full"
             [points]="placePoints"
             [zoom]="14"
             [enableClustering]="false"
             [setPointerOnLocation]="true">
    </app-map>
  </div>
}

</div>
